import { ChangeDetectorRef, Directive, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { UnitDetailsComponentForm } from '@portfolio/components/unit-details/config/enums/unit-details-component-form';
import { RestAddressModel } from '@shared/interfaces/address.interface';
import { RestApplianceModel } from '@shared/interfaces/appliance.interface';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { RestUnitModel } from '@shared/interfaces/unit.interface';
import { RestUserModel } from '@shared/interfaces/user.interface';

@Directive()
export abstract class UnitDetailsAbstract extends ComponentAbstract {
  readonly displayedColumns = [
    'applianceType',
    'id',
    'brand',
    'modelNumber',
    'serialNumberReplaced',
    'serialNumber',
    'applianceColor',
  ];
  dataSource: MatTableDataSource<RestApplianceModel>;

  propertyAddress = '';
  propertyManager = '';

  form: UntypedFormGroup;
  portfolioId: number;
  propertyId: number;
  turnoverId: number;
  applianceId: number;
  bulkBidId: number;
  unit: RestUnitModel;
  applianceInUnit: RestApplianceModel[] = [];
  applianceTypeList: IRadioButtonOption<number>[] = [];
  colorTypeList: IRadioButtonOption<number>[] = [];

  @Input() unitId: number;
  @Input() readOnly = true;

  protected constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  get UnitDetailsComponentForm(): typeof UnitDetailsComponentForm {
    return UnitDetailsComponentForm;
  }

  getPropertyAddress(physicalAddress: RestAddressModel): string {
    if (physicalAddress) {
      return `${physicalAddress?.street1 || ''} ${physicalAddress?.street2 || ''}, ${physicalAddress?.city || ''} ${
        physicalAddress?.zip || ''
      }`;
    }
    return '';
  }

  getPropertyManager(propertyManager: RestUserModel) {
    if (!propertyManager?.firstName && !propertyManager?.lastName) {
      return 'N/A';
    }
    return `${propertyManager?.firstName || ''} ${propertyManager?.lastName || ''}`;
  }
}
